/**
 * Noms des fonctions RPC Postgres (Supabase).
 * Source de vérité unique : ne jamais passer un nom de RPC en chaîne littérale
 * à `supabase.rpc(...)` — utiliser ces constantes pour éviter les fautes de frappe
 * et faciliter le renommage côté DB.
 */
export const RPC = {
  // Utilisateurs / prestataires
  GET_PROFILES_WITH_EMAIL: 'get_profiles_with_email',
  GET_PROVIDERS_AND_EXTERNALS: 'get_providers_and_externals',
  GET_PROVIDERS_LIST: 'get_providers_list',
  CHECK_USER_HAS_GOOGLE_IDENTITY: 'check_user_has_google_identity',
  LINK_OAUTH_USER_TO_INVITATION: 'link_oauth_user_to_invitation',
  MARK_INVITATION_USED: 'mark_invitation_used',
  /** Projets (id, nom) dont l'utilisateur connecté est membre, sans ouvrir la lecture de projects */
  GET_MY_MEMBER_PROJECTS: 'get_my_member_projects',
  /** Projets (id, nom) des factures d'un prestataire (le prestataire lui-même ou un admin) */
  GET_INVOICED_PROJECT_NAMES: 'get_invoiced_project_names',

  // Budget
  /** Budget vendu et engagé par activation × catégorie, pour le client et le lien public (sans marge) */
  GET_CLIENT_BUDGET_PROJECTION: 'get_client_budget_projection',

  // Tâches (ordre Kanban)
  INCREMENT_TASK_ORDER: 'increment_task_order',
  DECREMENT_TASK_ORDER: 'decrement_task_order',
  SHIFT_TASK_ORDERS: 'shift_task_orders',

  // Notifications
  MARK_NOTIFICATION_READ: 'mark_notification_read',
  MARK_ALL_NOTIFICATIONS_READ: 'mark_all_notifications_read',
  INSERT_ADMIN_NOTIFICATIONS: 'insert_admin_notifications',
} as const;

export type RpcName = (typeof RPC)[keyof typeof RPC];
